import React, { Component, PropTypes } from 'react';
import { RaisedButton, TextField } from 'material-ui';
import * as Icons from 'components/Material/SvgIcons';
import PageModule from 'components/PageModule';

export default class HelloWorld extends PageModule {
  static readable = 'Hello World';
  static icon = 'ActionAlarm';
  static type = 1000;
  static public = false;
  static active = true;

  onInit() {}

  getModuleData(moduleData) {
    return {
      ...moduleData,
      url: this.refs.url.getValue()
    };
  }

  getUserData(userdata) {
    const comments = ((userdata && userdata.comments) || []).slice();
    comments.push(this.refs.comment.getValue());
    return {
      comments
    };
  }

  renderEditMode(content, data) {
    return (
      <div>
        <TextField label="Url to the image" ref="url" defaultValue={data.url} />
      </div>
    );
  }

  comment() {
    this.saveUserData();
    this.refs.comment.clearValue();
  }

  renderDetailMode(content, data, userdata) {
    const savedComments = (userdata && userdata.comments) || [];
    const comments = savedComments.map((comment, index) => {
      return <div key={index}>{comment}</div>;
    });
    return (
      <div>
        <img src={data.url} />
        <b>Comment on this image</b>
        <TextField
          fullWidth
          onEnterKeyDown={::this.comment}
          label="Comment"
          ref="comment"
        />
        <br />
        <RaisedButton fullWidth label="Save" onTouchTap={::this.comment} />
        <RaisedButton
          fullWidth
          label="Clear"
          secondary
          onTouchTap={::this.clearUserData}
        />
        <div>
          <h2>Comments</h2>
          {comments}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/plugins/PageModules/HelloWorld.js